export class GoldenRecordDto {
  id: string;
  date: Date;
  platform: string;
  rawResponse: string;
  type: string;
  serialId: number;
  subType: string;
  uniqueId: string;
  account: string;
}
